import Vue from 'vue'
import Router from 'vue-router'
import {sde1Active} from '@/sunset-helper'
import LoginView from '@/components/views/Login'
import HomeView from '@/components/views/Home'
import DashboardView from '@/components/views/Dashboard'
import InvoiceView from '@/components/views/Accounting/Invoices'
import SapInvoiceView from '@/components/views/Accounting/SapInvoices'
import MonitoringErrors from '@/components/views/Monitoring/Errors'
import MonitoringJobs from '@/components/views/Monitoring/Jobs'
import MonitoringSap from '@/components/views/Monitoring/Sap'
import MonitoringErp from '@/components/views/Monitoring/ErpWorker'
import MonitoringMp from '@/components/views/Monitoring/MpWorker'
import MonitoringLabels from '@/components/views/Monitoring/Labels'
import MonitoringNews from '@/components/views/Monitoring/News'
import MonitoringStatistics from '@/components/views/Monitoring/Statistics'
import OrdersView from '@/components/views/Orders'
import LabelsView from '@/components/views/NewLabels'
import UploaderView from '@/components/views/Uploader'
import SingleOrderView from '@/components/views/OrderSingle'
import CompaniesView from '@/components/views/Accounting/Companies'
import CompanyView from '@/components/views/Accounting/Company'
import ErpView from '@/components/views/Accounting/AdvancedConfig'
import EditCompanyShipping from '@/components/views/Accounting/EditCompanyShipping'
import StoresView from '@/components/views/Accounting/Stores'
import StoreCreateView from '@/components/views/Accounting/StoreCreate'
import SingleStoreView from '@/components/views/Accounting/StoreSingle'
import MerchantStatsView from '@/components/views/Statistics/MerchantStatistics'
import ProductStatsView from '@/components/views/Statistics/ProductStatistics'
import TopSellerView from '@/components/views/Statistics/TopSeller'
import BrandMonitoringView from '@/components/views/Monitoring/Brands'
import ClickCollectView from '@/components/views/ClickCollectOverview'
import SingleClickCollectView from '@/components/views/SingleClickCollect'
import ControllingStatsView from '@/components/views/ControllingStatsView'
import Fibu from '@/components/views/Fibu'
import Overview from '@/components/views/Overviews/Overview'
import SapOverview from '@/components/views/Overviews/SapOverview'
import ProductDetail from '@/components/views/SingleProduct'
import AvisUpload from '@/components/views/AvisUploader'
import FeesView from '@/components/views/Company/MarketplaceTax.vue'
import SapSalesChannelConf from '@/components/views/Sap/SapSalesChannelConf'
import OverviewUnknown from '@/components/views/Overviews/OverviewUnknown'
import OverviewComplaints from '@/components/views/Overviews/OverviewComplaints'
import TransactionsAnalysisCollectiveBillingMP from '@/components/views/TransactionsAnalysisCollectiveBillingMP'
import SchuheDeFileDownload from '@/components/views/SchuheDeFileDownload'
import CountryCarrierSettings from '@/components/views/CountryCarrierSettings'
import PriceModelSettings from '@/components/views/PriceModelSettings'
import AmazonConfiguration from '@/components/views/AmazonConfiguration'
import EditFees from '@/components/views/Accounting/EditFees'
import OktaLogin from "@/components/views/OktaLogin";
import Redirect from "@/components/views/Redirect";
import AnwrRedirect from "@/components/views/AnwrRedirect";

Vue.use(Router)

function requireSde1 (to, from, next) {
  if (sde1Active()) {
    next()
  } else {
    next('/home')
  }
}

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/okta-login',
      name: 'okta-login',
      component: OktaLogin,
    },
    {
      path: '/',
      redirect: '/okta-login'
    },
    {
      path: '/redirect',
      name: 'Redirect',
      component: Redirect
    },
    {
      path: '/anwr-redirect',
      name: 'AnwrRedirect',
      component: AnwrRedirect
    },
    {
      path: '/home',
      component: HomeView,
      meta: {
        auth: true
      },
      children: [
        {
          path: '',
          component: DashboardView,
          name: 'dashboard',
          description: 'dashboard',
          meta: {
            auth: true
          }
        },
        {
          path: '/orders',
          component: OrdersView,
          name: 'orders',
          description: 'Orders Table',
          meta: {
            auth: true
          }
        },
        {
          path: '/orders/:id',
          component: SingleOrderView,
          name: 'single_order',
          meta: {
            auth: true
          }
        },
        {
          path: '/click-and-collect',
          component: ClickCollectView,
          name: 'click-and-collect',
          meta: {
            auth: true
          }
        },
        {
          path: '/click-and-collect/:id',
          component: SingleClickCollectView,
          name: 'reservation',
          meta: {
            auth: true
          }
        },
        {
          path: '/statistics/product-stats',
          beforeEnter: requireSde1,
          component: ProductStatsView,
          name: 'product_statistics',
          meta: {
            auth: true
          },
          description: 'Statistics viewer'
        },
        {
          path: '/statistics/product-stats/:company/:id',
          beforeEnter: requireSde1,
          component: ProductDetail,
          name: 'single_product',
          meta: {
            auth: true
          }
        },
        {
          path: '/statistics/merchant-stats',
          component: MerchantStatsView,
          name: 'merchant_stats',
          meta: {
            auth: true
          },
          description: 'Statistics viewer'
        },
        {
          path: '/statistics/top-seller-stats',
          component: TopSellerView,
          name: 'top-seller-stats',
          meta: {
            auth: true
          },
          description: 'Statistics viewer'
        },
        {
          path: '/monitoring/job-monitoring',
          component: MonitoringJobs,
          name: 'job-monitoring',
          description: 'Monitoring Jobs',
          meta: {
            auth: true
          }
        },
        {
          path: '/monitoring/sap-monitoring',
          component: MonitoringSap,
          name: 'sap-monitoring',
          description: 'Monitoring SAP',
          meta: {
            auth: true
          }
        },
        {
          path: '/monitoring/erp-monitoring',
          component: MonitoringErp,
          name: 'erp-monitoring',
          description: 'Monitoring ERP Jobs',
          meta: {
            auth: true
          }
        },
        {
          path: '/monitoring/mp-monitoring',
          component: MonitoringMp,
          name: 'mp-monitoring',
          description: 'Monitoring Marketplace Jobs',
          meta: {
            auth: true
          }
        },
        {
          path: '/monitoring/order-errors',
          component: MonitoringErrors,
          name: 'order-errors',
          description: 'Monitoring Overview',
          meta: {
            auth: true
          }
        },
        {
          path: '/monitoring/label-errors',
          component: MonitoringLabels,
          name: 'label-errors',
          description: 'Monitoring Labels',
          meta: {
            auth: true
          }
        },
        {
          path: '/monitoring/notifications',
          component: MonitoringNews,
          name: 'notifications',
          description: 'Create notifications',
          meta: {
            auth: true
          }
        },
        // {
        //   path: '/monitoring/error-log',
        //   component: MonitoringLogs,
        //   name: 'error-log',
        //   description: 'Monitoring Error Log',
        //   meta: {
        //     auth: true
        //   }
        // },
        {
          path: '/monitoring/stats-monitoring',
          component: MonitoringStatistics,
          name: 'stats-monitoring',
          description: 'Monitor Statistics',
          meta: {
            auth: true
          }
        },
        {
          path: '/monitoring/brands-monitoring',
          beforeEnter: requireSde1,
          component: BrandMonitoringView,
          name: 'brands-monitoring',
          description: 'Monitoring brands',
          meta: {
            auth: true
          },
        },
        {
          path: '/controlling/stats',
          component: ControllingStatsView,
          name: 'stats',
          meta: {
            auth: true
          }
        },
        {
          path: '/controlling/fibu',
          component: Fibu,
          name: 'fibu',
          meta: {
            auth: true
          }
        },
        {
          path: '/labels',
          component: LabelsView,
          name: 'labels',
          description: 'Labels',
          meta: {
            auth: true
          },
          props: true
        },

        {
          path: '/overview/unknown-status',
          component: OverviewUnknown,
          name: 'unknown-status',
          meta: {
            auth: true
          }
        },
        {
          path: '/overview/complaints',
          component: OverviewComplaints,
          name: 'complaints',
          meta: {
            auth: true
          }
        },
        {
          path: '/overview/sap',
          component: SapOverview,
          name: 'sap_overview',
          meta: {
            auth: true
          }
        },
        {
          path: '/overview/:type',
          component: Overview,
          name: 'overview',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/companies',
          parent: 'accounting',
          component: CompaniesView,
          name: 'companies',
          description: 'Companies Overview',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/companies/:id',
          component: CompanyView,
          parent: 'accounting',
          name: 'company',
          description: 'Company Account page',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/companies/:id/fees',
          component: FeesView,
          parent: 'accounting',
          name: 'fees',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/companies/:id/config/erp',
          component: ErpView,
          parent: 'accounting',
          name: 'erp_configuration',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/companies/:id/config/shipping',
          component: EditCompanyShipping,
          parent: 'accounting',
          name: 'shipping_configurations',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/stores',
          parent: 'accounting',
          component: StoresView,
          name: 'stores_overview',
          description: 'Store management',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/stores/new',
          parent: 'stores',
          grandparent: 'accounting',
          component: StoreCreateView,
          name: 'create_store',
          description: 'Store management',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/companies/:company_id/stores/:id',
          parent: 'company',
          grandparent: 'accounting',
          component: SingleStoreView,
          name: 'single_store',
          description: 'Store management',
          meta: {
            auth: true
          }
        },
        {
          path: '/accounting/companies/:companyId/amazonconfiguration',
          component: AmazonConfiguration,
          name: 'AmazonConfiguration',
          meta: {
            auth: true
          }
        },
        {
          path: '/download/invoices/:type',
          parent: 'accounting',
          component: InvoiceView,
          name: 'invoices_overview',
          description: 'Invoice management',
          meta: {
            auth: true
          }
        },
        {
          path: '/download/sap/invoices/:type',
          parent: 'accounting',
          component: SapInvoiceView,
          name: 'sap_invoices_overview',
          description: 'Invoice management',
          meta: {
            auth: true
          }
        },
        {
          path: '/upload-manager',
          component: UploaderView,
          name: 'upload-manager',
          meta: {
            auth: true
          }
        },
        {
          path: '/schuhede-stats',
          component: SchuheDeFileDownload,
          name: 'schuhede-stats',
          meta: {
            auth: true
          }
        },
        {
          path: '/country-carriers-settings',
          component: CountryCarrierSettings,
          name: 'country-carriers-settings',
          meta: {
            auth: true
          }
        },
        {
          path: '/price-model-settings',
          component: PriceModelSettings,
          name: 'price-model-settings',
          meta: {
            auth: true
          }
        },
        {
          path: '/avis-upload',
          component: AvisUpload,
          name: 'avis-upload',
          meta: {
            auth: true
          }
        },
        {
          path: '/transactions-analysis-collective-billing-mp',
          component: TransactionsAnalysisCollectiveBillingMP,
          name: 'transactions_analysis_collective_billing_mp',
          meta: {
            auth: true
          }
        },
        {
          path: '/edit-fees',
          component: EditFees,
          name: 'edit-fees',
          meta: {
            auth: true
          }
        },
        {
          path: '/sap-saleschannels-conf',
          component: SapSalesChannelConf,
          name: 'sap-saleschannels-conf',
          meta: {
            auth: true
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js